<as-split>
    <as-split-area [size]="50">
        <ag-grid-angular *ngIf="gridActivated" style="width: 100%; height: calc(100% - 5px); margin-top: 4px;"
            [rowData]="templates" [gridOptions]="gridOptions" [ngClass]="agGridTheme" [columnDefs]="cols"
            [defaultColDef]="defaultColDef" rowSelection="single" (gridReady)="onGridReady($event)"
            (selectionChanged)="onSelectionChanged()">
        </ag-grid-angular>
    </as-split-area>
    <as-split-area>
        <app-proposal-template-edit></app-proposal-template-edit>
    </as-split-area>
</as-split>
